// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeRange_root__3EVfJ","bookingInfo":"TimeRange_bookingInfo__38nAg","dateSection":"TimeRange_dateSection__2VWHx"};